import { render, staticRenderFns } from "./DiscountCouponBanner.vue?vue&type=template&id=956d1248&scoped=true"
import script from "./DiscountCouponBanner.vue?vue&type=script&lang=js"
export * from "./DiscountCouponBanner.vue?vue&type=script&lang=js"
import style0 from "./DiscountCouponBanner.vue?vue&type=style&index=0&id=956d1248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956d1248",
  null
  
)

export default component.exports